import { SupplierModel } from '@app/models/SupplierModel';
import { SupplierRepository } from '@app/repositories/SupplierRepository';
import { ServiceBase } from '@app/services/ServiceBase';

export class SupplierService extends ServiceBase<SupplierModel, SupplierRepository<SupplierModel>> {
    public constructor() {
        super(new SupplierRepository());
    }
}
